import { fromJS } from 'immutable';
import { makeImmutable } from 'utils/immutableUtils';
import { SET_RUNTIME_CONFIG } from './constants';

const initialState = fromJS({
  DEPLOYMENT_ENVIRONMENT: '',
});

function runtimeConfigReducer(state = initialState, action) {
  switch (action.type) {
    case SET_RUNTIME_CONFIG:
      return state.setIn([], makeImmutable(action.config));
    default:
      return state;
  }
}

export default runtimeConfigReducer;
